import React, { Component } from "react";
import PropTypes from "prop-types";
import { Switch } from "antd";
import { connect } from "react-redux";
import {
	displayComVisit,
	makeIsComLocationChecked,
	makeIsComVisitChecked,
} from "../../../../redux/selectors/survey/createSelector";
import {
	addEndVisitStatementAction,
	removeEndVisitStatementAction,
} from "../../../../redux/actions/surveyActions";

function ComVisit(props) {
	if (!props.display) return null;

	return (
		<div className="p-al-v-center">
			<span className="p-pdg-right-s">Commentaire de fin de visite </span>
			<Switch
				checked={props.checked}
				onChange={checked => {
					if (checked) {
						props.addEndVisitStatementAction();
					} else {
						props.removeEndVisitStatementAction();
					}
				}}
			/>
		</div>
	);
}

ComVisit.propTypes = {};

const makeMapStateToProps = () => {
	const isComVisitChecked = makeIsComVisitChecked();

	const mapStateToProps = (state, props) => {
		return {
			checked: isComVisitChecked(state, props),
			display: displayComVisit(state),
		};
	};

	return mapStateToProps;
};

const mapDispatchToProps = (dispatch, props) => {
	return {
		addEndVisitStatementAction: () => {
			dispatch(addEndVisitStatementAction());
		},
		removeEndVisitStatementAction: () => {
			dispatch(removeEndVisitStatementAction());
		},
	};
};

export default connect(
	makeMapStateToProps,
	mapDispatchToProps
)(ComVisit);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/ComVisit.js